// extracted by mini-css-extract-plugin
export default {"title":"bf79ecab7b","inner_title":"_29a8269e0c","charge_btn":"_121d5485e4"};